import { render, staticRenderFns } from "./edition-toolbox.vue?vue&type=template&id=fd23676c&scoped=true&"
import script from "./edition-toolbox.vue?vue&type=script&lang=ts&"
export * from "./edition-toolbox.vue?vue&type=script&lang=ts&"
import style0 from "./edition-toolbox.vue?vue&type=style&index=0&id=fd23676c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd23676c",
  null
  
)

export default component.exports